import { USER_COOKIE } from "@src/constants/constants";
import StorageUtils from "@src/utils/storageUtils";
import SignolUtils from "@src/utils/signolUtils";
import { shippingCaptainNotifications } from "../shipping/notifications";
import { aviationCaptainNotifications } from "../aviation/notifications";

const getMonthStringsFromDate = (date) => {
  const monthDate = new Date(
    date.getFullYear(),
    date.getMonth(),
    date.getDate(),
  );
  const previousMonthDate = new Date(
    date.getFullYear(),
    date.getMonth() - 1,
    1,
  );

  const monthYear = monthDate.toLocaleString("en-GB", {
    month: "long",
    year: "numeric",
  });

  const monthOnly = monthDate.toLocaleString("en-GB", {
    month: "long",
  });
  const monthDay = monthDate.toLocaleString("en-GB", {
    month: "long",
    day: "numeric",
  });

  return { monthYear, monthOnly, monthDay };
};

export const getOperatorFeed = ({
  limit = 10,
  offset = 0,
  subtypes = [],
  industry,
}) => {
  const isShipping = industry
    ? industry === "SHIPPING"
    : SignolUtils.getIndustry() === "shipping";
  const notifications = isShipping
    ? shippingCaptainNotifications
    : aviationCaptainNotifications;
  const data = notifications
    .filter(
      (notification) =>
        !subtypes.length || subtypes.includes(notification.category),
    )
    .slice(offset, limit);

  const currentUser = StorageUtils.getObjectItem(USER_COOKIE);
  const currentUseritem = StorageUtils.getItem("currentUser");

  const bvr1DescShipping = "Use optimal cargo load for your ship";
  const bvr2DescShipping =
    "Meet or beat the planned amount of fuel for your voyage";
  const bvr3DescShipping =
    "Use auxiliary power for your ship only when required";

  const bvr1DescAviation =
    "Do not start all engine(s) during taxi out on 15% of flights";
  const bvr2DescAviation =
    "Meet or beat the planned amount of fuel for your flight on 45% of flights";
  const bvr3DescAviation =
    "Shut down engine(s) during taxi in on 35% of flights ";

  const formatted = [];
  data.forEach((notification) => {
    const notifDate = getMonthStringsFromDate(notification.createdAt);
    notification.content = notification.content.replaceAll(
      "MONTHYEAR",
      notifDate.monthYear,
    );
    notification.content = notification.content.replaceAll(
      "MONTHDAY",
      notifDate.monthOnly + " 4th",
    );
    if (currentUser) {
      notification.content = notification.content.replaceAll(
        "FIRSTNAME",
        currentUser.firstname,
      );
      notification.content = notification.content.replaceAll(
        "LASTNAME",
        currentUser.lastname,
      );
    } else {
      notification.content = notification.content.replaceAll(
        "FIRSTNAME",
        isShipping ? "Viktor" : "Alan",
      );
      notification.content = notification.content.replaceAll(
        "LASTNAME",
        isShipping ? "Marinov" : "Rogers",
      );
    }
    notification.content = notification.content.replaceAll(
      "ROLE",
      isShipping ? "Chief Engineer" : "Captain",
    );

    notification.content = notification.content.replaceAll(
      "YEAR",
      `${new Date(notification.createdAt).getFullYear()}`,
    );
    notification.content = notification.content.replaceAll(
      "MONTH1NUM",
      `${new Date(notification.createdAt).getMonth()}`,
    );
    notification.content = notification.content.replaceAll(
      "MONTH1",
      new Date(notification.createdAt).toLocaleString("default", {
        month: "long",
      }),
    );
    notification.content = notification.content.replaceAll(
      "MONTH2NUM",
      `${new Date(notification.createdAt).getMonth() - 1}`,
    );
    notification.content = notification.content.replaceAll(
      "MONTH2",
      `${new Date(
        new Date(notification.createdAt).setMonth(
          new Date(notification.createdAt).getMonth() - 1,
        ),
      ).toLocaleString("default", {
        month: "long",
      })}`,
    );
    notification.content = notification.content.replaceAll(
      "BVR1DESC",
      isShipping ? bvr1DescShipping : bvr1DescAviation,
    );
    notification.content = notification.content.replaceAll(
      "BVR2DESC",
      isShipping ? bvr2DescShipping : bvr2DescAviation,
    );
    notification.content = notification.content.replaceAll(
      "BVR3DESC",
      isShipping ? bvr3DescShipping : bvr3DescAviation,
    );
    if (isShipping) {
      notification.content = notification.content.replaceAll(
        "Reduced Engine Taxi In",
        "Efficient Auxiliary Engine Usage",
      );
      notification.content = notification.content.replaceAll(
        "Reduced Engine Taxi Out",
        "Optimal Trim",
      );
      notification.content = notification.content.replaceAll(
        "Efficient Flight",
        "Optimal Sailing",
      );
      notification.content = notification.content.replaceAll("RETI", "EAEU");
      notification.content = notification.content.replaceAll("RETO", "OT");
      notification.content = notification.content.replaceAll(" EF ", " OS ");
      notification.content = notification.content.replaceAll("Flight", "Day");
      notification.content = notification.content.replaceAll("FLIGHT", "DAY");
      notification.content = notification.content.replaceAll("flight", "day");
      notification.content = notification.content.replaceAll(
        "aviation",
        "shipping",
      );
      notification.content = notification.content.replaceAll("LHR", "Port 1");
      notification.content = notification.content.replaceAll("MEX", "Port 1");
      notification.content = notification.content.replaceAll("JFK", "Port 2");
      notification.content = notification.content.replaceAll("MID", "Port 2");
      notification.content = notification.content.replaceAll("HKG", "Port 2");
      notification.content = notification.content.replaceAll(
        "55 tonnes",
        "450 tonnes",
      );
      notification.content = notification.content.replaceAll(
        "8 tonnes",
        "45 tonnes",
      );
      notification.content = notification.content.replaceAll(
        "68k liters",
        "900k liters",
      );
      notification.content = notification.content.replaceAll("liter", "litre");
      notification.content = notification.content.replaceAll(
        "3k trees",
        "400k trees",
      );
      notification.content = notification.content.replaceAll("24k", "220k");
      notification.content = notification.content.replaceAll("3.5k", "24k");
      notification.content = notification.content.replaceAll(
        "75 tonnes",
        "750 tonnes",
      );
      notification.content = notification.content.replaceAll(
        "125 tonnes",
        "1,250 tonnes",
      );
      notification.content = notification.content.replaceAll(
        "4021 trees",
        "40k trees",
      );
      notification.content = notification.content.replaceAll(
        "6530 trees",
        "65k trees",
      );
    }
    formatted.push(notification);
  });
  return formatted;
};

export const shippingFormattedNotifications = getOperatorFeed({
  limit: 10,
  offset: 0,
  subtypes: [],
  industry: "SHIPPING",
});

export const aviationFormattedNotifications = getOperatorFeed({
  limit: 10,
  offset: 0,
  subtypes: [],
  industry: "AVIATION",
});
